import { init as initAmplitude } from '@amplitude/analytics-browser';

import { environment } from '../environment';

initAmplitude(environment.amplitude.apiKey, undefined, {
  serverZone: 'EU',
  defaultTracking: false,
});
